export default {
  title: 'Recognized Attorneys',
  inputPlaceholder: 'Attorney Name',
  saveButton: 'Save',
  cancelButton: 'Cancel',
  saveSuccessMessage: 'Successfully saved',
};
